<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد ترانسفر شرکت
        </b-button>
      </b-col>
    </b-row>
    <div v-if="transfer_companies">
      <div class="d-flex justify-content-between align-items-center">
        <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage" />
        <!-- <search
          ref="residencesSearchComponent"
          class="w-50"
          v-model="searchInput"
        /> -->
      </div>

      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>عنوان</b-th>
            <b-th>شماره دفتر</b-th>
            <b-th>شماره موبایل</b-th>
            <b-th>آدرس</b-th>
            <b-th>وضعیت</b-th>
            <b-th>عملیات</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="category in transfer_companies" :key="category.id">
            <b-td>{{ category.title }}</b-td>
            <b-td>{{ category.phone }}</b-td>
            <b-td>{{ category.mobile }}</b-td>
            <b-td>{{ category.address }}</b-td>

            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0"
                  :class="
                  category.status != 'active' ? 'text-danger' : 'text-success'
                "
              >
                {{ category.status == "active" ? "" : "غیر" }}فعال
              </b-col></b-td
            >
            <b-td>
              <b-col class="d-flex align-items-center">
<!--                <b-button
                    @click="showConfirmModal(category)"
                    variant="flat-danger"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Trash2Icon" size="20" />
                </b-button>-->
                <b-button
                    @click="showFormModal(category)"
                    variant="flat-secondary"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Edit2Icon" size="20" />
                </b-button> </b-col
              ></b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <pagination
          ref="residencesPaginationComponent"
          v-model="page"
          :paginationData="paginationData"
      />
    </div>
    <b-sidebar
        width="750px"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش ترانسفر شرکت " : "ایجاد ترانسفر شرکت " }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="">
        <b-form-group class="mt-1">
          <label for="name" class="text-capitalize"> نام ترانسفر شرکت  : </label>
          <b-form-input @input="removeErrors('name')" id="name" v-model="categoryInput.title" type="text" />
          <ErrorMessage
              errorType="name"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="address" class="text-capitalize"> آدرس ترانسفر شرکت : </label>
          <b-form-input @input="removeErrors('address')" id="address" v-model="categoryInput.address" type="text" />
          <ErrorMessage
              errorType="address"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="phone" class="text-capitalize"> شماره دفتر یا موبایل ترانسفر شرکت : </label>
          <b-form-input @input="removeErrors('phone')" id="phone" v-model="categoryInput.phone" type="text" />
          <ErrorMessage
              errorType="phone"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>


        <b-form-group>
          <label for="residence_area" class="text-capitalize">
            نوع ترانسفر .<span class="text-danger">*</span>
          </label>
          <v-select
              id="residence_area"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              v-model="categoryInput.transfer_type"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="transferType"
          />
        </b-form-group>

        <b-form-group class="mt-1 col-md-6" v-slot="{ ariaDescribedby }">
          <label for="province_status" class="text-capitalize"> وضعیت : </label>
          <b-form-checkbox
              v-model="categoryInput.status"
              :aria-describedby="ariaDescribedby"
              value="active"
              @input="removeErrors('status')"
          >فعال</b-form-checkbox
          >
          <b-form-checkbox
              v-model="categoryInput.status"
              :aria-describedby="ariaDescribedby"
              value="inactive"
              @input="removeErrors('status')"
          >پیش نویس</b-form-checkbox
          >
          <ErrorMessage
              errorType="status"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>




        <b-form-group class="mt-1">
          <label for="description" class="text-capitalize"> توضیحات : </label>
          <b-form-input
              id="description"
              v-model="categoryInput.body"
              type="text"
              @input="removeErrors('description')"
          />
          <ErrorMessage
              errorType="description"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="">
          <label for="imageIcon" class="text-capitalize">
            آپلود تصویر ایکون:
          </label>
          <FilePicker
              @inputFile="inputIconImageFile"
              :url="iconImageurl"
              ref="iconImageFilePicker"
          ></FilePicker>
          <ErrorMessage
              errorType="image"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormCheckbox,
  BTableSimple,
  BThead,
  BTbody,
  BFormSelect,
  BTr,
  BTh,
  BTd, BIconCalendar,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import ErrorMessage from "@/components/ErrorMessage.vue";
import FilePicker from "@/components/FilePicker.vue";

export default {
  components: {
    BIconCalendar,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    BFormSelect,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    ErrorMessage,
    BFormCheckbox,
    FilePicker,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  data() {
    return {

      optionsShow:[
        { value: null, text: 'انتخاب نمایش در ص اصلی' },
        { value: '0', text: 'عدم نمایش در صفحه اصلی' },
        { value: '1', text: 'نمایش در صفحه اصلی' },
      ],

      iconImageurl:"",
      errorMessage: {},
      perPage: 10,
      page: 1,
      buildings: [],
      transfer_companies: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "تصویر آیکن",
          slug: "image_icon",
          sortable: false,
        },
        {
          title: "آیکن",
          slug: "icon",
          sortable: false,
        },
        {
          title: "عنوان",
          slug: "name",
          sortable: true,
        },
        {
          title: "توضیحات",
          slug: "description",
          sortable: true,
        },
        {
          title: "نمایش در صفحه",
          slug: "show_index_page",
          sortable: true,
        },
        {
          title: "تاریخ ایجاد",
          slug: "created_at",
          sortable: true,
        },

        {
          title: "وضعیت",
          slug: "status",
          sortable: false,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      buildingsCancelToken: undefined,
      owners: [],
      transferType: [
        "airplane",
        "train",
        "bus",
        "van",
        "freight",
        "others",
      ],

      categoryInput: {
        id: "",
        title: "",
        address:"",
        phone: "",
        transfer_type:"",
        body:"",
        image: null,
        status:"",
      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getCategories();
    this.getBuildings();
    this.getOwners();
  },

  watch: {
    searchInput(value) {
      this.page = 1;
      this.getCategories();
    },
    perPage(value) {
      this.page = 1;
      this.getCategories();
    },
    page(value) {
      this.getCategories();
    },
  },
  methods: {
    async getOwners() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false,
        //  "filter[name]": this.selectedFilter.includes("name")
        //     ? this.searchInput
        //     : "",
        //   "filter[email]": this.selectedFilter.includes("email")
        //     ? this.searchInput
        //     : "",
        //   "filter[mobile]": this.selectedFilter.includes("mobile")
        //     ? this.searchInput
        //     : "",
        per_page: 5000,
        //   page: this.page,
      };

      const requestData = {
        method: "get",
        url: "/admin/users/host",
        params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.owners = data.data;
            this.paginationData = data.meta;
            this.searchBasesubmitLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.searchBasesubmitLoading = false;
          });
    },
    inputIconImageFile(file) {
      this.removeErrors("image");
      this.categoryInput.image = file;
    },
    removeErrors(data) {
      if (
          typeof this.errorMessage[data] !== "undefined" &&
          this.errorMessage[data].length > 0
      ) {
        // this.errorMessage[data][0]="salllam"
        delete this.errorMessage[data];
        this.errorMessage = Object.assign(
            {},
            this.errorMessage,
            this.errorMessage
        );
        console.log(data, this.errorMessage);
      }
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getCategories();
    },

    async getCategories() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        // search: this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/tours/transfer_companies",
        // params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.transfer_companies = data.data;
            this.paginationData = data.meta;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    showConfirmModal(category) {
      this.$bvModal
          .msgBoxConfirm(
              `آیا از حذف ترانسفر شرکت  مطمئن هستید ؟  : ${category.name}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let residenceIndex = 0;
              this.transfer_companies = await this.transfer_companies.filter(
                  (residenceItem, index) => {
                    if (residenceItem.id == category.id) {
                      residenceIndex = index;
                    }
                    return residenceItem.id !== category.id;
                  }
              );

              const requestData = {
                method: "delete",
                url: `/admin/tours/transfer_companies/${category.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `ترانسفر شرکت : ${category.name}  با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.transfer_companies.splice(residenceIndex, 0, category);
                  });
            }
          });
    },
    showFormModal(category) {
      if (category) {
        this.categoryInput = {
          id: category.id,
          title: category.title,
          address: category.address,
          phone: category.phone,
          body: category.body,
          transfer_type: category.transfer_type,
          status: category.status,
          image: null,
        };
        this.$refs.iconImageFilePicker.clearFileInput()
        this.iconImageurl=category.image.path
        this.editMode = true;
      } else {
        this.categoryInput = {
          title: "",
          address: "",
          phone: "",
          transfer_type: "",
          status: "",
          image: "",
          body: "",
        };
        this.$refs.iconImageFilePicker.clearFileInput()
        this.iconImageurl=""
        this.editMode = false;
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!errorMessage && !this.categoryInput.title) {
        errorMessage = "لطفا نام ترانسفر شرکت  را وارد کنید";
      }
  /*    if (!errorMessage && !this.categoryInput.slug) {
        errorMessage = "لطفا اسلاگ ترانسفر شرکت  را وارد کنید";
      }*/

/*      let formData = new FormData();

      if (this.categoryInput.title) {
        formData.append("title", this.categoryInput.title);
      }
     if (this.categoryInput.slug) {
        formData.append("slug", this.categoryInput.slug);
      }
      if (this.categoryInput.status) {
        formData.append("status", this.categoryInput.status);
      }
      if (this.categoryInput.show_index_page) {
        formData.append("show_index_page", this.categoryInput.show_index_page);
      }
      if (this.categoryInput.description) {
        formData.append("description", this.categoryInput.description);
      }
      if (this.categoryInput.image) {
        formData.append("image", this.categoryInput.image);
      }
      if (this.categoryInput.icon) {
        formData.append("icon", this.categoryInput.icon);
      }*/
      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "post" : "post",
        url: this.editMode
            ? `/admin/tours/transfer_companies/update/${this.categoryInput.id}`
            : `/admin/tours/transfer_companies`,
        data: this.categoryInput,
      };

      this.$http(requestData)
          .then((response) => {
            let message = "ترانسفر شرکت  با موفقیت اضافه شد";
            if (this.editMode) message = "ترانسفر شرکت  با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            if (!this.editMode && this.buildings && this.buildings.length > 0) {
              this.$refs.residencesPaginationComponent.clear();
              // this.$refs.residencesSearchComponent.clear();
              this.$refs.residencesTableHeadComponent.clear();
              this.page = 1;
              this.searchInput = "";
              this.sortBy = "";
              this.sortDir = "";
            }

            this.submitLoading = false;
            this.formModal = false;
            this.getCategories();
          })
          .catch((err) => {
            let message = "خطا در ایجاد ترانسفر شرکت ";
            if (this.editMode) message = "خطا در ویرایش ترانسفر شرکت ";
            if (
                err.response &&
                err.response.data &&
                err.response.data.response &&
                err.response.data.response.message
            )
              message = err.response.data.response.message;
            if (
                err.response &&
                err.response.data &&
                err.response.data.response &&
                err.response.data.response.meta &&
                err.response.data.response.meta.errors
            )
              this.errorMessage = err.response.data.response.meta.errors;
            console.log("this.errorMessage", this.errorMessage);

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },
    getBuildings(search, loading) {
      if (typeof this.buildingsCancelToken != typeof undefined) {
        this.buildingsCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.buildingsCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "buildings",
        params: data,
        cancelToken: this.buildingsCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data.data;
            this.buildings = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
